import * as Device from 'expo-device'
import { Platform } from 'react-native'

import { isMobile } from 'utils/deviceDetect'

export const IS_IOS = Platform.OS === 'ios'
export const IS_ANDROID = Platform.OS === 'android'

export const IS_WEB = typeof window !== 'undefined' && !IS_IOS && !IS_ANDROID
export const IS_PWA =
  isMobile &&
  typeof window !== 'undefined' &&
  window?.matchMedia('(display-mode: standalone)').matches

export const HAS_ISLAND = IS_IOS && Device.modelId.includes('iPhone15')
